import { Text, View } from '@react-pdf/renderer'
import type React from 'react'

import { PdfStyles } from './pdfStyles'

export const PdfFieldRow: React.FC<{
  label: string
  children: React.ReactNode
}> = ({ label, children }) => (
  <View style={PdfStyles.descriptionRow} wrap={false}>
    <Text style={PdfStyles.descriptionLabel}>{label}</Text>
    <View style={PdfStyles.descriptionValue}>{children}</View>
  </View>
)
